// ActivityLogModal.jsx
import { useState, useEffect, useMemo } from "react";
import axios from "axios";

const ActivityLogModal = ({ isOpen, onClose, apiurl, subdomain = "react" ,index}) => {

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate]     = useState();
  const [headers, setHeaders]   = useState([]);
  const [rows, setRows]         = useState([]);
  const [loading, setLoading]   = useState(false);

  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  // ── Filter state per column ───────────────────────────────────
  const [openFilter, setOpenFilter]   = useState(null);   // column name
  const [filterVals, setFilterVals]   = useState({});     // { col: inputVal }
  const [appliedFilters, setApplied]  = useState({});     // { col: appliedVal }

  // date range filter for Planned Date
  const [appname,setName] = useState(null);
  const [realHeaders,setRealhead] = useState([]);
  // ── Sort state ────────────────────────────────────────────────
  const [sortCol, setSortCol]   = useState(null);
  const [sortDir, setSortDir]   = useState("asc");
  
  const fetchLogs = async (from, to, tabIndex = activeTab) => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiurl}activity.php`, {
        params: {from_date: from, to_date: to,type:index,tab: tabIndex  },
      });
      setHeaders(res.data.headers || []);
      setRows(res.data.rows || []);
      setRealhead(res.data.real || []);
      setFromDate(res.data.fromDate);
      setTabs(res.data.tabs || []);
      setToDate(res.data.toDate);
      setName(res.data.name);
      setApplied({});
      setSortCol(null);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
    if (isOpen) {
        setActiveTab(0);
        fetchLogs(fromDate, toDate, 0);
    }
    }, [isOpen]);

  useEffect(() => {
    const handler = () => setOpenFilter(null);
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);
  
  const applyFilter = (col) => {
    setApplied(prev => ({ ...prev, [col]: filterVals[col] || "" }));
    setOpenFilter(null);
  };

  const clearFilter = (col) => {
    setApplied(prev => ({ ...prev, [col]: "" }));
    setFilterVals(prev => ({ ...prev, [col]: "" }));
  };

  // ── Sort toggle ───────────────────────────────────────────────
  const handleSort = (col) => {
    if (sortCol === col) {
      setSortDir(d => d === "asc" ? "desc" : "asc");
    } else {
      setSortCol(col);
      setSortDir("asc");
    }
  };

 

  // ── Filtered + sorted rows ────────────────────────────────────
  const processed = useMemo(() => {
    let data = [...rows];

    // Apply text filters
    Object.entries(appliedFilters).forEach(([col, val]) => {
      if (!val) return;
      if (col === "Planned Date") return; // handled separately
      data = data.filter(row =>
        String(row[col] ?? "").toLowerCase().includes(val.toLowerCase())
      );
    });

    // Sort
    if (sortCol) {
      data.sort((a, b) => {
        const av = String(a[sortCol] ?? "").toLowerCase();
        const bv = String(b[sortCol] ?? "").toLowerCase();
        if (av < bv) return sortDir === "asc" ? -1 : 1;
        if (av > bv) return sortDir === "asc" ?  1 : -1;
        return 0;
      });
    }

    return data;
  }, [rows, appliedFilters, sortCol, sortDir]);

  if (!isOpen) return null;

  const isFiltered = (col) => {
    return !!appliedFilters[col];
  };

const fetchReqDetail = async (from,to,ii) => {
  setLoading(true);

  try {
    const res = await axios.get(`${apiurl}activity_log.php`, {
        params: {from_date: from, to_date: to,type:index, number:ii },
    });
    setRealhead(res.data.real || []);
    setHeaders(res.data.headers || []);
    setRows(res.data.rows || []);
} catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

// ── Status color helper ───────────────────────────────────────
const getStatusColor = (status) => {
  if (!status) return "#10B981";
  const s = status.toLowerCase();
  if (s === "onhold")  return "#eb0a0a";
  if (s === "closed")  return "#e26206";
  return "#10B981"; // pending/open = green
};

  return (
<>
 <div style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.45)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
      onClick={onClose} >

      <div style={{
          background: "#fff", borderRadius: 12, width: "95%",
          maxWidth: 1200, maxHeight: "90vh",
          display: "flex", flexDirection: "column", overflow: "hidden",
        }}
        onClick={e => e.stopPropagation()} >

        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 20px", borderBottom: "1px solid #e5e7eb",
        }}>

          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 500 }}>Activity Log </h2>
          <p>App Name : <span>{appname}</span></p>
          <button onClick={onClose} style={{
            background: "none", border: "none", fontSize: 22,
            cursor: "pointer", color: "#6b7280",
          }}>&times;</button>

        </div>

        {/* Date filter bar */}
        <div style={{
          display: "flex", alignItems: "center", gap: 12,
          padding: "12px 20px", borderBottom: "1px solid #f3f4f6", flexWrap: "wrap",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <label style={{ fontSize: 13, color: "#6b7280" }}>From</label>
            <input type="date" value={fromDate}
              onChange={e => setFromDate(e.target.value)}
              style={{ fontSize: 13, padding: "4px 8px", borderRadius: 6, border: "1px solid #e5e7eb" }}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <label style={{ fontSize: 13, color: "#6b7280" }}>To</label>
            <input type="date" value={toDate}
              onChange={e => setToDate(e.target.value)}
              style={{ fontSize: 13, padding: "4px 8px", borderRadius: 6, border: "1px solid #e5e7eb" }}
            />
          </div>
          <button onClick={() => fetchLogs(fromDate, toDate)} style={{
            fontSize: 13, padding: "5px 16px", borderRadius: 6,
            background: "#2563eb", color: "#fff", border: "none", cursor: "pointer",
          }}>Search</button>
          <span style={{ fontSize: 12, color: "#9ca3af", marginLeft: "auto" }}>
            {processed.length} records
          </span>
        </div>

        {tabs.length > 0 && (
  <div style={{
    display: "flex",
    gap: 10,
    padding: "10px 20px",
    borderBottom: "1px solid #e5e7eb"
  }}>
    {tabs.map((t, i) => (
      <button
        key={i}
        onClick={() => {
          setActiveTab(i);
          if (i === 0) {
            fetchLogs(fromDate, toDate, 0);   // 🔥 first tab
          } else {
            fetchReqDetail(fromDate, toDate,i);                // 🔥 second tab
          }
        }}
        style={{
          padding: "6px 14px",
          fontSize: 13,
          borderRadius: 6,
          border: "none",
          cursor: "pointer",
          background: activeTab === i ? "#2563eb" : "#f3f4f6",
          color: activeTab === i ? "#fff" : "#374151",
        }}
      >
        {t}
      </button>
    ))}
  </div>
)}

        {/* Table */}
        <div style={{ overflowY: "auto", flex: 1 }}>
          {loading && (
            <div style={{ padding: 40, textAlign: "center", color: "#6b7280" }}>Loading...</div>
           )}
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#f9fafb" }}>
                  {headers.map((h, i) => (
                    <th key={i} style={{
                      padding: "10px 12px", textAlign: "left", fontWeight: 500,
                      color: "#374151", borderBottom: "1px solid #e5e7eb",
                      whiteSpace: "nowrap", position: "sticky", top: 0,
                      background: "#f9fafb", zIndex: 10,
                    }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>

                        {/* Column name + sort */}
                        <span
                          onClick={() => handleSort(h)}
                          style={{ cursor: "pointer", userSelect: "none", display: "flex", alignItems: "center", gap: 3 }}
                        >
                          {h}
                          {sortCol === h ? (
                            <span style={{ fontSize: 10 }}>{sortDir === "asc" ? " ▲" : " ▼"}</span>
                          ) : (
                            <span style={{ fontSize: 10, color: "#d1d5db" }}> ⇅</span>
                          )}
                        </span>

                        {/* Filter dot button */}
                        <div style={{ position: "relative", marginLeft: "auto" }}>
                          <button
                            onClick={e => { e.stopPropagation(); setOpenFilter(openFilter === h ? null : h); }}
                            style={{
                              background: isFiltered(h) ? "#2563eb" : "none",
                              border: "none", cursor: "pointer", padding: "2px 4px",
                              borderRadius: 4, fontSize: 14, color: isFiltered(h) ? "#fff" : "#9ca3af",
                              lineHeight: 1,
                            }}
                            title="Filter"
                          >⋯</button>

                          {/* Filter dropdown */}
                          {openFilter === h && (
                            <div
                              onClick={e => e.stopPropagation()}
                              style={{
                                position: "absolute", top: "100%", right: 0, zIndex: 999,
                                background: "#fff", border: "1px solid #e5e7eb",
                                borderRadius: 8, padding: 12, minWidth: 220,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                              }}
                            >
                              {h.toLowerCase().includes("date") ? (
                                <>
                                    <p style={{ fontSize: 11, color: "#6b7280", margin: "0 0 6px" }}>Filter by date</p>
                                    <input
                                    type="date"
                                    value={filterVals[h] || ""}
                                    onChange={e => setFilterVals(prev => ({ ...prev, [h]: e.target.value }))}
                                    style={{
                                        width: "100%", fontSize: 12, padding: "4px 6px",
                                        borderRadius: 5, border: "1px solid #e5e7eb",
                                        marginBottom: 8, boxSizing: "border-box",
                                    }}
                                    />
                                    <div style={{ display: "flex", gap: 6 }}>
                                    <button onClick={() => applyFilter(h)} style={{
                                        flex: 1, fontSize: 12, padding: "4px 0", borderRadius: 5,
                                        background: "#2563eb", color: "#fff", border: "none", cursor: "pointer",
                                    }}>Search</button>
                                    <button onClick={() => clearFilter(h)} style={{
                                        flex: 1, fontSize: 12, padding: "4px 0", borderRadius: 5,
                                        background: "#f3f4f6", color: "#374151", border: "none", cursor: "pointer",
                                    }}>Clear</button>
                                    </div>
                                </>
                                ) : (
                                // ── existing text filter ──────────────────────────────
                                <>
                                    <p style={{ fontSize: 11, color: "#6b7280", margin: "0 0 6px" }}>Search in {h}</p>
                                    <input
                                    type="text"
                                    placeholder={`Filter ${h}...`}
                                    value={filterVals[h] || ""}
                                    onChange={e => setFilterVals(prev => ({ ...prev, [h]: e.target.value }))}
                                    onKeyDown={e => { if (e.key === "Enter") applyFilter(h); }}
                                    autoFocus
                                    style={{
                                        width: "100%", fontSize: 12, padding: "5px 8px",
                                        borderRadius: 5, border: "1px solid #e5e7eb",
                                        marginBottom: 8, boxSizing: "border-box", outline: "none",
                                    }}
                                    />
                                    <div style={{ display: "flex", gap: 6 }}>
                                    <button onClick={() => applyFilter(h)} style={{
                                        flex: 1, fontSize: 12, padding: "4px 0", borderRadius: 5,
                                        background: "#2563eb", color: "#fff", border: "none", cursor: "pointer",
                                    }}>Search</button>
                                    <button onClick={() => clearFilter(h)} style={{
                                        flex: 1, fontSize: 12, padding: "4px 0", borderRadius: 5,
                                        background: "#f3f4f6", color: "#374151", border: "none", cursor: "pointer",
                                    }}>Clear</button>
                                    </div>
                                </>
                                )}
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
            <tbody>
  {processed.length === 0 ? (
    <tr>
      <td colSpan={headers.length} style={{
        textAlign: "center",
        padding: "20px",
        color: "#9ca3af"
      }}>
        No records found
      </td>
    </tr>
  ) : (
    processed.map((row, ri) => (
      <tr key={`row-${ri}`}
        onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
      >
        {realHeaders.map((h, ci) => (
          <td key={ci} style={{
            padding: "9px 12px",
            color: "#4b5563",
            whiteSpace: "nowrap"
          }}>
            {h === "reqid" ? (
              <span style={{
                color: getStatusColor(row["status"]),
                fontWeight: 500,
                fontSize: 13
              }}>
                {row["reqid"]}
              </span>
            ) : (
              <span dangerouslySetInnerHTML={{ __html: row[h] ?? "—" }} />
            )}
          </td>
        ))}
      </tr>
    ))
  )}
</tbody>
            </table>
         
        </div>
      </div>
    </div>
    </>
  );
};

export default ActivityLogModal;